import { ElMessage } from "element-plus";

function isWindows() {
  // 检测 userAgent 和 platform 中的 Windows 标识
  return /Win32|Win64|Windows|WinCE/i.test(navigator.userAgent) ||
    /Win32|Win64|Windows|WinCE/i.test(navigator.platform);
}

//tauri 窗口
const tauriWindow = {
  openWindow(url) {
    let _isWindows = isWindows()
    if(_isWindows){
        window.open(url, "_blank")
        return
    }
    try {
      const invoke = window.__TAURI__.core.invoke;
      invoke('open_default_brower', { url });
    } catch (e) {
      ElMessage.error('当前客服端版本过低，请下载安装最新客户端!!');
      console.error(e)
    }
  }
}
export default {
  install: async (app) => {
    app.provide('tauriWindow', tauriWindow);
  },
};